import { ScreeningInsightsResponse } from '@estercare/ester-shared'
import { ComponentLayout } from '../../components/layouts/ComponentLayout'
import { OrganisationNeedsSection } from '../../components/admin/statistics/sections/OrganisationNeedsSection'
import { StyledTitle1 } from './Index'

const MOCK_INSIGHTS: ScreeningInsightsResponse = {
  severityByCondition: {
    nTotal: 142,
    coveragePct: 100,
    conditions: [
      { key: 'pmsPmds', label: 'PMS/PMDS', n: 48, counts: { mild: 12, moderate: 22, severe: 14 } },
      { key: 'menopause', label: 'Perimenopaus / Klimakteriet', n: 42, counts: { mild: 16, moderate: 20, severe: 6 } },
      { key: 'menstrualPain', label: 'Mensvärk', n: 26, counts: { mild: 14, moderate: 6, severe: 6 } },
      { key: 'incontinence', label: 'Inkontinens', n: 23, counts: { mild: 11, moderate: 7, severe: 5 } },
      { key: 'heavyBleeding', label: 'Rikliga blödningar', n: 18, counts: { mild: 5, moderate: 8, severe: 5 } },
    ],
  },
  severeScreenings: { pct: 31, n: 142, coveragePct: 100 },
  careNeedLevel3: { pct: 22, n: 122, coveragePct: 100 },
  ageDistribution: {
    n: 142,
    coveragePct: 100,
    bands: [
      { key: 'lte_29', label: '–29', count: 6 },
      { key: '30_34', label: '30–34', count: 11 },
      { key: '35_39', label: '35–39', count: 19 },
      { key: '40_44', label: '40–44', count: 27 },
      { key: '45_49', label: '45–49', count: 34 },
      { key: '50_54', label: '50–54', count: 23 },
      { key: '55_59', label: '55–59', count: 17 },
      { key: '60_plus', label: '60–', count: 5 },
    ],
  },
  productivityBySeverity: {
    nTotal: 142,
    coveragePct: 100,
    tiers: [
      {
        key: 'mild',
        n: 58,
        bands: [
          { key: 'low', label: '0–3', pct: 91 },
          { key: 'moderate', label: '4–6', pct: 6 },
          { key: 'high', label: '7–10', pct: 3 },
        ],
      },
      {
        key: 'moderate',
        n: 63,
        bands: [
          { key: 'low', label: '0–3', pct: 70 },
          { key: 'moderate', label: '4–6', pct: 21 },
          { key: 'high', label: '7–10', pct: 9 },
        ],
      },
      {
        key: 'severe',
        n: 36,
        bands: [
          { key: 'low', label: '0–3', pct: 42 },
          { key: 'moderate', label: '4–6', pct: 33 },
          { key: 'high', label: '7–10', pct: 25 },
        ],
      },
    ],
  },
}

// Every metric below its gate: the shape a young organisation actually gets back.
const MOCK_SUPPRESSED_INSIGHTS: ScreeningInsightsResponse = { exportDate: '2026-08-31' }

// A pooled tier and widened age bands, as the API returns them for a smaller organisation.
const MOCK_MERGED_INSIGHTS: ScreeningInsightsResponse = {
  ...MOCK_INSIGHTS,
  ageDistribution: {
    n: 44,
    coveragePct: 100,
    bands: [
      { key: 'lte_34', label: '–34', count: 8 },
      { key: '35_44', label: '35–44', count: 14 },
      { key: '45_54', label: '45–54', count: 16 },
      { key: 'gte_55', label: '55–', count: 6 },
    ],
  },
  productivityBySeverity: {
    nTotal: 44,
    coveragePct: 100,
    tiers: [
      {
        key: 'mildModerate',
        n: 38,
        bands: [
          { key: 'low', label: '0–3', pct: 79 },
          { key: 'moderate', label: '4–6', pct: 16 },
          { key: 'high', label: '7–10', pct: 5 },
        ],
      },
      {
        key: 'severe',
        n: 6,
        bands: [
          { key: 'low', label: '0–3', pct: 33 },
          { key: 'moderate', label: '4–6', pct: 34 },
          { key: 'high', label: '7–10', pct: 33 },
        ],
      },
    ],
  },
}

export const OrganisationNeedsComponentLibrary = () => (
  <ComponentLayout>
    <StyledTitle1>Organisation needs</StyledTitle1>
    <OrganisationNeedsSection insights={MOCK_INSIGHTS} />
    <StyledTitle1>Organisation needs — merged bands and tiers</StyledTitle1>
    <OrganisationNeedsSection insights={MOCK_MERGED_INSIGHTS} />
    <StyledTitle1>Organisation needs — below every threshold</StyledTitle1>
    <OrganisationNeedsSection insights={MOCK_SUPPRESSED_INSIGHTS} />
  </ComponentLayout>
)
